/* eslint-disable max-len */
import React from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import styled from 'styled-components';
import {contentUrlSolver, debugCNitoUrl, slugify} from '../../../helpers';
import {breakpoints, mobileMediaQuery, tabletMediaQuery} from '../../../styles';
import ContentBox from '../../ContentBox';

const SearchResultGrid = ({shows, games}) => {
    const images = useSelector(state => state.config.images);
    const history = useHistory();

    const onClickShow = (title, show) => {
        history.push(`/shows/${slugify(show.title)}${debugCNitoUrl()}`);
    };

    const onClickGame = (title, game) => {
        history.push(`/games/play/${slugify(game.title)}-${game.id}`);
    };

    if (!shows && !games) {
        return null;
    }

    return (
        <>
            <Container>
                {shows &&
                    shows.map(item => (
                        <VStack>
                            <StyledBox
                                key={item.id}
                                id={item.id}
                                data={item}
                                favouritesGrid={false}
                                highlight={item.highlight}
                                title={item.title}
                                background={contentUrlSolver(
                                    {images},
                                    item.image,
                                    'BACKGROUND',
                                    'png',
                                    '?imwidth=300',
                                )}
                                action={() => onClickShow(item.title, item)}
                                cnito={false}
                            />
                            <Title>{item.title}</Title>
                        </VStack>
                    ))}
            </Container>
            <Container>
                {games &&
                    games.map(item => (
                        <StyledGameBox
                            key={item.id}
                            id={item.id}
                            data={item}
                            featured={false}
                            hideFavouriteButton
                            background={item.image}
                            title={item.showName}
                            sub={item.title}
                            type="game"
                            action={() => onClickGame(item.id, item)}
                        />
                    ))}
            </Container>
        </>
    );
};

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 16px;
    width: 100%;
    margin-bottom: 16px;

    ${mobileMediaQuery} {
        grid-template-columns: 1fr;
    }
    @media screen and (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md}px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.sm}px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const StyledBox = styled(ContentBox)`
    width: 100% !important;
    height: 0 !important;
    min-width: initial !important;
    min-height: initial !important;
    padding-bottom: calc(9 / 16 * 100%);
    grid-column: auto / span;
`;

const StyledGameBox = styled(ContentBox)`
    width: 100% !important;
    height: 0 !important;
    min-width: initial !important;
    min-height: initial !important;
    max-width: initial !important;
    max-height: initial !important;
    padding-bottom: calc(74.43 / 100 * 100%);
    grid-column: auto / span;
`;

const VStack = styled.div`
    display: flex;
    flex-direction: column;
`;

const Title = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0.0225em;
    text-transform: uppercase;
    color: #ffffff;
    margin-top: 10px;
    text-overflow: clip;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${tabletMediaQuery} {
        text-size: 12px;
    }
    ${mobileMediaQuery} {
        text-size: 10px;
    }
`;

export default SearchResultGrid;
